export const sitAtTable = 'action/table_on';
export type TableActionPayload = {
  type: typeof sitAtTable;
  id: string;
  state: string;
};
